module.exports = __webpack_public_path__ + "img/tipicon-curriculum.23ed4344.svg";